(function () {
  'use strict';

  // ---- 定数 ----
  const THRESHOLD_NORMAL  = 8700;
  const THRESHOLD_REMOTE  = 11000;
  const REMOTE_PROVINCES  = ['北海道', 'Hokkaido', '沖縄県', 'Okinawa'];
  const BOUNDARY_RATIO    = THRESHOLD_NORMAL / THRESHOLD_REMOTE;

  // ---- キャッシュ ----
  const sgCache       = {}; // variant_id → shipping_group
  const fetchedHandle = {}; // handle → 取得済みフラグ

  // ---- ユーティリティ ----
  function isRemote(province) {
    if (!province) return false;
    return REMOTE_PROVINCES.some(p => province.includes(p));
  }

  // ---- product.fsbビューでshipping_group取得 ----
  async function fetchShippingGroupsByHandle(handle) {
    if (fetchedHandle[handle]) return; // 取得済みはスキップ
    fetchedHandle[handle] = true;

    try {
      const res  = await fetch(`/products/${handle}?view=fsb&t=${Date.now()}`);
      const data = await res.json();
      (data.variants || []).forEach(v => {
        sgCache[v.id] = v.sg || '';
      });
    } catch (err) {
      console.error(`[FSB] ${handle} の取得エラー:`, err);
    }
  }

  // ---- カート内の全商品のshipping_groupを取得 ----
  async function fetchAllShippingGroups(cartItems) {
    const handles = [...new Set(cartItems.map(item => item.handle))];
    await Promise.all(handles.map(h => fetchShippingGroupsByHandle(h)));
  }

  // ---- カート解析 ----
  function analyzeCart(cartItems) {
    let nonSubscTotal = 0;
    let hasSubsc      = false;
    let hasFree       = false;
    let hasNew        = false;
    let hasDelivery   = false;
    let allSubsc      = true;

    cartItems.forEach(item => {
      const sg    = sgCache[item.variant_id] || '';
      const price = item.final_line_price / 100;

      if (sg === 'ship-subsc') {
        hasSubsc = true;
      } else {
        allSubsc = false;
        nonSubscTotal += price;
        if (sg === 'ship-free')     hasFree     = true;
        if (sg === 'ship-new')      hasNew      = true;
        if (sg === 'ship-delivery') hasDelivery = true;
      }
    });

    return { nonSubscTotal, hasSubsc, hasFree, hasNew, hasDelivery, allSubsc };
  }

  // ---- バー状態の計算 ----
  function calcBarState(cartItems) {
    const {
      nonSubscTotal, hasSubsc, hasFree, hasNew, hasDelivery, allSubsc
    } = analyzeCart(cartItems);

    const province     = window.CustomerProvince || '';
    const addressKnown = province !== '';
    const remote       = isRemote(province);

    function withSubsc(state) {
      if (hasSubsc && !allSubsc) {
        return { ...state, text: state.text + '（定期は別送・送料無料）' };
      }
      return state;
    }

     // 優先判定1: subsc商品のみ
    if (allSubsc && hasSubsc) {
      return { ratio: 1, text: '定期購入は送料無料です', isFree: true, showBoundary: false };
    }

    // 優先判定2: ship-free商品がカートに含まれる
    if (hasFree) {
      return { ratio: 1, text: '送料無料です', isFree: true, showBoundary: false };
    }

    if (!addressKnown) {
      // ---- a. 住所取得不可 ----
      if (nonSubscTotal >= THRESHOLD_REMOTE || (hasNew && !hasDelivery)) {
        return { ratio: 1, text: '送料無料です', isFree: true, showBoundary: false };
      } else if (nonSubscTotal >= THRESHOLD_NORMAL) {
        const ratio = nonSubscTotal / THRESHOLD_REMOTE;
        const need  = Math.ceil(THRESHOLD_REMOTE - nonSubscTotal);
        return withSubsc({ ratio, isFree: false, showBoundary: false, text: `送料無料です（北海道・沖縄の場合はあと${need.toLocaleString()}円必要です）` });
      } else {
        const ratio = nonSubscTotal / THRESHOLD_REMOTE;
        const need  = Math.ceil(THRESHOLD_NORMAL - nonSubscTotal);
        return withSubsc({ ratio, isFree: false, showBoundary: true, text: `あと${need.toLocaleString()}円で送料無料です（北海道・沖縄はさらに1,300円必要です）` });
      }

    } else if (!remote) {
      // ---- b. 北海道・沖縄以外 ----
      if (nonSubscTotal >= THRESHOLD_NORMAL || (hasNew && !hasDelivery)) {
        return { ratio: 1, text: '送料無料です', isFree: true, showBoundary: false };
      } else {
        const ratio = nonSubscTotal / THRESHOLD_NORMAL;
        const need  = Math.ceil(THRESHOLD_NORMAL - nonSubscTotal);
        return withSubsc({ ratio, isFree: false, showBoundary: false, text: `あと${need.toLocaleString()}円で送料無料です` });
      }

    } else {
      // ---- c. 北海道・沖縄 ----
      if (nonSubscTotal >= THRESHOLD_REMOTE || (hasNew && !hasDelivery)) {
        return { ratio: 1, text: '送料無料です', isFree: true, showBoundary: false };
      } else {
        const ratio = nonSubscTotal / THRESHOLD_REMOTE;
        const need  = Math.ceil(THRESHOLD_REMOTE - nonSubscTotal);
        return withSubsc({ ratio, isFree: false, showBoundary: false, text: `あと${need.toLocaleString()}円で送料無料です` });
      }
    }
  }

  // ---- DOM更新 ----
  function updateBars(state) {
    document.querySelectorAll('.fsb-wrapper').forEach(wrapper => {
      const textEl     = wrapper.querySelector('.fsb-text');
      const progressEl = wrapper.querySelector('.fsb-progress');
      const boundaryEl = wrapper.querySelector('.fsb-boundary');

      if (textEl) {
        textEl.textContent = state.text;
        textEl.classList.toggle('is-free', state.isFree);
      }
      if (progressEl) {
        const pct = Math.min(state.ratio * 100, 100).toFixed(1);
        progressEl.style.width = pct + '%';
        progressEl.classList.toggle('is-complete', state.isFree);
      }
      if (boundaryEl) {
        boundaryEl.style.display = state.showBoundary ? 'block' : 'none';
        if (state.showBoundary) {
          boundaryEl.style.left = (BOUNDARY_RATIO * 100).toFixed(1) + '%';
        }
      }
    });
  }

  // ---- メイン処理 ----
  async function refreshBar() {
    try {
      const res  = await fetch('/cart.js');
      const cart = await res.json();

      if (!cart.items || cart.items.length === 0) {
        updateBars({
          ratio: 0,
          text: `¥${THRESHOLD_NORMAL.toLocaleString()}以上で送料無料（北海道・沖縄は¥${THRESHOLD_REMOTE.toLocaleString()}以上）`,
          isFree: false,
          showBoundary: false
        });
        return;
      }

      await fetchAllShippingGroups(cart.items);
      updateBars(calcBarState(cart.items));

    } catch (err) {
      console.error('[FSB] refreshBar エラー:', err);
    }
  }

  // ---- fetch インターセプト（カートドロワー対応）----
  const _originalFetch = window.fetch;
  window.fetch = async function (...args) {
    const response = await _originalFetch.apply(this, args);
    const url = typeof args[0] === 'string' ? args[0] : (args[0]?.url || '');
    if (/\/cart\/(change|update|add)/.test(url)) {
      setTimeout(refreshBar, 300); // 300ms後に更新
    }
    return response;
  };

  // ---- イベントリスニング ----
  window.addEventListener('cart_changed',         refreshBar);
  window.addEventListener('cart:updated',         refreshBar);
  window.addEventListener('cart:refresh',         refreshBar);
  window.addEventListener('dispatch:cart-update', refreshBar);
  document.addEventListener('DOMContentLoaded',   refreshBar);

})();
